import React, { useCallback, useState , useEffect } from 'react'
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate , useLocation} from 'react-router-dom';
import StatusFilter from '../../../components/Filter/DayFilter/StatusFilter/StatusFilter';
import "./AddCustomerPage.css"
import AddBtn from '../../../components/Buttons/Add/AddBtn';
import { RiFilePaper2Line } from "react-icons/ri";
import DeleteBtn from '../../../components/Buttons/Delete/DeleteBtn';
import { useCustomerContext } from '../../../components/Context/CustomerContext';
import { Table } from 'react-bootstrap';
import TotalOrders from '../Analytics/Graphs/TotalOrders';
import { FaMinus } from "react-icons/fa";
import { VscCreditCard } from "react-icons/vsc";
import { useSegments } from '../../../components/Context/SegmentsContext';
import SubmitBtn from '../../../components/Buttons/Submit/SubmitBtn';
import { IoAddOutline } from "react-icons/io5";
import { addCustomer,updateCustomer , deleteCustomer , addMoneyToWallet ,subtractMoneyFromWallet , getWalletTransactions } from '../../../services/CustomerService';
import { getAllSegment } from '../../../services/SegmentService';
import StatusInput from '../../../components/StatusInput/StatusInput';
import { FiDownload } from "react-icons/fi";
import { downloadCreditReceipt } from '../../../services/InvoiceServices';
import SelectState from '../../../components/SelectState/SelectState';
import Toast from '../../../components/Toast/Toast';
import { Download, Link, X } from 'lucide-react';

import { uploadProductImage } from '../../../services/ProductService';


const AddCustomerPage = () => {
const backendUrl = process.env.REACT_APP_IMAGE_URL
  const { state } = useLocation();
  const { index, customers } = state || {};
  const { rows, setRows } = useSegments();
  const [errors, setErrors] = useState({});
  const [toasts, setToasts] = useState([]);
  const [showPreview, setShowPreview] = useState(false);


  const [selectedAddressType, setSelectedAddressType] = useState("HOME");



  const navigate =useNavigate()
  // const { customers ,setCustomers } = useCustomerContext();
  const [segments,setSegments] = useState([])
      
  useEffect(() => {
      const fetchData = async () => {
        try {
          const data = await getAllSegment();
          setSegments(data.data)
          
        } catch (error) {
          console.error('Error fetching products:', error);
        }
      };
    
      fetchData(); 
    }, []); 

  const customer =  (typeof index === 'number' && customers) ? customers[index] : null;

  const [amount, setAmount] = useState(""); // Amount input
  const [source, setSource] = useState("");


  const [status,setStatus] = useState(customer?.customerStatus || 'Active')

  const [formData, setFormData] = useState(() => {
    const nameParts = customer?.customerName?.split(" ") || [];
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";
    return {
      firstName,
      lastName,
      email: customer?.email || "",
      phone: customer?.phoneNumber || "",
      whatsapp: customer?.whatsappNumber || "",
      company: customer?.company || "",
      gstin: customer?.gstNumber || "",
      chequePhoto: customer?.cancelledCheque || "",
      address: customer?.customerAddress || "",
      street: customer?.street || "",
      country: customer?.country || "",
      state: customer?.state || "",
      city: customer?.city || "",
      pinCode: customer?.zipcode || "",
      // password: customer?.password || "",
    };
  });

  
  // Update initialFormData when customer changes
  useEffect(() => {
    if (!customer || !selectedAddressType) return;
  
    const addressOfType = customer.addresses?.find(
      addr => addr.addressType === selectedAddressType
    );
  
    const nameParts = customer?.customerName?.split(" ") || [];
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";
  
    const updatedForm = {
      firstName,
      lastName,
      email: customer?.email || "",
      phone: customer?.phoneNumber || "",
      whatsapp: customer?.whatsappNumber || "",
      company: customer?.company || "",
      gstin: customer?.gstNumber || "",
      chequePhoto: customer?.cancelledCheque || "",
      address: addressOfType?.customerAddress || "",
      street: addressOfType?.street || "",
      country: addressOfType?.country || "",
      state: addressOfType?.state || "",
      city: addressOfType?.city || "",
      pinCode: addressOfType?.zipcode || "",
      password: customer?.password || "",
    };
  
    setFormData(updatedForm);
   
  }, [customer, selectedAddressType]);
  
  const [selectedSegments, setSelectedSegments] = useState(customer?.segments || []);
  const [searchTerm, setSearchTerm] = useState('');  // State for input field

  
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [walletBalance,setWalletBalance] = useState()

  const fetchTransactions = async () => {
    if (customer===null) return;
   
    const customerId = customer.customerId; 
   
    setLoading(true);
    try {
     
      const data = await getWalletTransactions(customerId);
      setTransactions(data); // Update state with API response
    } catch (error) {
      console.error("Error loading transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  
    fetchTransactions();
  }, [customer]);

  

  useEffect(() => {
    if (transactions?.length > 0) {
      const total = transactions.reduce((acc, item) => {
        return item.type === "CREDIT"
          ? acc + parseFloat(item.amount)
          : acc - parseFloat(item.amount);
      }, 0); // Initial value is 0
      setWalletBalance(total);
    } else {
      setWalletBalance(0); // Set to 0 if no transactions
    }
  }, [transactions]);

  

  const filteredSegments = segments.filter((segment) =>
    segment.segmentTitle.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const [selectedValue, setSelectedValue] = useState(""); // State to reset dropdown

  const addSegmentAsChip = (event) => {
    const segmentTitle = event.target.value;
    if (!segmentTitle) return;
  
    const selectedSegment = segments.find(seg => seg.segmentTitle === segmentTitle);
    
    const alreadyAdded = selectedSegments.some(
      seg => seg.segmentTitle === selectedSegment?.segmentTitle
    );
  
    if (selectedSegment && !alreadyAdded) {
      setSelectedSegments([...selectedSegments, selectedSegment]);
    }
  
    setSelectedValue("");
  };

console.log(selectedSegments)
  

const removeSegmentChip = (index) => {
  setSelectedSegments(selectedSegments.filter((_, i) => i !== index));
};
  
  const handleStatusChange = (stat) =>{
     setStatus(stat)
  }


  const handleAddMoney = async () => {
     const showToast = (message, type = "error") => {
            setToasts([{ message, type }]);
            setTimeout(() => setToasts([]), 3000);
          };
    if (!amount || isNaN(amount)) {
      return showToast("Enter a valid amount.", "error");
    }
  
    try {
      const customerId = customer.customerId;
      await addMoneyToWallet(customerId, amount, source || "Manual credit");
      fetchTransactions();
      setAmount("");
      setSource("");
      showToast("Money added successfully.", "success");
    } catch (error) {
      showToast("Failed to add money to wallet.", "error");
    }
  };

  const handleSubtractMoney = async () => {
     const showToast = (message, type = "error") => {
            setToasts([{ message, type }]);
            setTimeout(() => setToasts([]), 3000);
          };
    if (!amount || isNaN(amount)) {
      return showToast("Enter a valid amount.", "error");
    }
  
    try {
      const customerId = customer.customerId;
      await subtractMoneyFromWallet(customerId, amount, source || "Manual debit");
      fetchTransactions();
      setAmount("");
      setSource("");
      showToast("Money deducted successfully.", "success");
    } catch (error) {
      showToast("Failed to subtract money from wallet.", "error");
    }
  };

 

const handleAddressTypeChange = (e) => {
  const type = e.target.value;
  setSelectedAddressType(type);

  const selectedAddress = customer?.addresses?.find(addr => addr.addressType === type) || {};
  setFormData(prev => ({
    ...prev,
    address: selectedAddress.customerAddress || "",
    street: selectedAddress.street || "",
    country: selectedAddress.country || "",
    state: selectedAddress.state || "",
    city: selectedAddress.city || "",
    pinCode: selectedAddress.zipcode || "",
  }));
};


  const handleChange = (e) => {
    const { name, value, files } = e.target;

   
    const updatedFormData = {
        ...formData,
        [name]: files ? files[0] : value,
    };

    setFormData(updatedFormData);
   
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrors({}); // Reset errors

    let validationErrors = {};

    // Validate Required Fields
    if (!formData.firstName?.trim()) validationErrors.firstName = "First name is required.";
    if (!formData.lastName?.trim()) validationErrors.lastName = "Last name is required.";
    if (!formData.phone?.trim()) validationErrors.phone = "Phone number is required.";
    if (!formData.email?.trim()) validationErrors.email = "Email is required.";
    if (!formData.password?.trim()) validationErrors.password = "Password is required.";
    if (!formData.company?.trim()) validationErrors.company = "Company is required.";
    if (!formData.street?.trim()) validationErrors.street = "Apartment,Suite etc is required.";
    if (!formData.country?.trim()) validationErrors.country = "Country name is required.";
    if (!formData.state?.trim()) validationErrors.state = "State is required.";
    if (!formData.city?.trim()) validationErrors.city = "City is required.";
    if (!/^\d{10}$/.test(formData.phone)) validationErrors.phone = "Enter a valid 10-digit phone number.";
    if (!formData.whatsapp?.trim()) validationErrors.whatsapp = "WhatsApp number is required.";
    if (!/^\d{10}$/.test(formData.whatsapp)) validationErrors.whatsapp = "Enter a valid 10-digit WhatsApp number.";
    // if (!formData.gstin?.trim()) validationErrors.gstin = "GST number is required.";
    // if (!/^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[Z]{1}\d{1}$/.test(formData.gstin))
    //     validationErrors.gstin = "Enter a valid GSTIN.";
    if (!formData.pinCode?.trim()) validationErrors.pinCode = "Pincode is required.";
    if (!/^\d{6}$/.test(formData.pinCode)) validationErrors.pinCode = "Enter a valid 6-digit pincode.";
    if (!formData.address?.trim()) validationErrors.address = "Address is required.";
    // if (selectedSegments.length === 0) validationErrors.segmentIds = "Select at least one segment.";

    // Stop submission if errors exist
    if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
    }

    const existingAddresses = [...(customer?.addresses || [])];
    const addressIndex = existingAddresses.findIndex(
      addr => addr.addressType === selectedAddressType
    );
  
    const existingAddress = existingAddresses[addressIndex];
    const updatedAddress = {
      ...(existingAddress?.id ? { id: existingAddress.id } : {}),
      customerAddress: formData.address,
      street: formData.street,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      zipcode: formData.pinCode,
      addressType: selectedAddressType,
    };
  
    if (addressIndex !== -1) {
      existingAddresses[addressIndex] = updatedAddress;
    } else {
      existingAddresses.push(updatedAddress);
    }
  
    const segmentIds = selectedSegments.map(segment => segment.segmentId || segment.id);
  
    const newCustomer = {
      customerName: `${formData.firstName} ${formData.lastName}`,
      phoneNumber: formData.phone,
      whatsappNumber: formData.whatsapp,
      gstNumber: formData.gstin,
      email: formData.email,
      company: formData.company,
      cancelledCheque: formData.chequePhoto || "",
      customerStatus: status.toUpperCase(),
      segmentIds,
      addresses: existingAddresses.slice(0, 3), // enforce max 3 types
      customerAddress: formData.address,
      zipcode: formData.pinCode,
      ...(state?.index === undefined && { password: formData.password }) // only include password if creating
    };
    
    try {
      if (state?.index !== undefined) {
        // Update existing customer
        await updateCustomer(customer.customerId, newCustomer);
      
      } else {
        // Add new customer
        await addCustomer(newCustomer);
      
      }
  
      navigate('/customers'); 
    } catch (error) {
      console.error("Error saving customer:", error);
     
    }
  };

  const handleDownloadCreditReceipt = async (source) => {
    const lowerSource = source.toLowerCase();
    const isCancellation = lowerSource.includes("cancellation");
    const isReturn = lowerSource.includes("return");
  
    // Extract orderId (last number after 'order:') and optionally returnedId (number after 'item:')
    const orderIdMatch = source.match(/order:\s*(\d+)/i);
    const returnedIdMatch = source.match(/item:\s*(\d+)/i);
  
    const orderId = orderIdMatch ? orderIdMatch[1] : null;
    const returnedId = returnedIdMatch ? returnedIdMatch[1] : null;
  
    if (!orderId || (!isCancellation && !isReturn)) {
      console.error("Invalid source format:", source);
      return;
    }
  
    const type = isCancellation ? "cancelled" : "returned";
  
    try {
      if (type === "returned") {
        if (!returnedId) {
          console.error("Returned ID missing for return type");
          return;
        }
        await downloadCreditReceipt(orderId, type, returnedId);
      } else {
        await downloadCreditReceipt(orderId, type);
      }
    } catch (error) {
      console.error("Failed to download credit receipt:", error);
    }
  };
  



  const handleDelete = async() =>{
    const confirmed = window.confirm("Are you sure you want to delete this Customer?");
    if (!confirmed) return;

       try {
          const id = customer.customerId
          await deleteCustomer(id)
          navigate('/customers'); // Redirect after submission
        } catch (error) {
          // Handle error (optional)
          console.error('Error Deleting product:', error);
        }
  }

const handleChequePhotoChange = async (e) => {
          const file = e.target.files[0];
          if (!file) return;

          try {
            const res = await uploadProductImage(file,"customer"); // Implement this backend uploader
            const uploadedUrl = res.data;

            setFormData((prev) => ({
              ...prev,
              chequePhoto: uploadedUrl,
            }));
          } catch (error) {
            // showToast('Cheque photo upload failed. Please try again.', 'error');
          }
        };


       const handleDownloadChequePhoto = () => {
          if (!formData.chequePhoto) {
            console.error("No cheque photo URL provided");
            return;
          }

          const url = `${backendUrl}${formData.chequePhoto}`;
          window.open(url, '_blank');
        };




         const handleCopyImageLink = async () => {
    try {
      const imageUrl = `${backendUrl}${formData.chequePhoto}`;
      await navigator.clipboard.writeText(imageUrl);
      alert('Image link copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy link:', err);
      alert('Failed to copy link');
    }
  };

  const handleImageClick = () => {
    setShowPreview(true);
  };

  const handleClosePreview = () => {
    setShowPreview(false);
  };

 
  return (
    <div className='add-customer'>

      {state?.index !== undefined ? (
          <div className='top d-flex  gap-3 align-items-center mt-3 mb-4 '>
                    <span onClick={() => navigate("/customers")} style={{ cursor: "pointer" }}>
                    <IoArrowBackOutline size={25} />
                </span>
          <h3 className='m-0' style={{fontSize:'1.2rem'}}>{customer.customerName}</h3>
        </div>
          ):
          (
        <div className='top d-flex gap-3 align-items-center mt-3 mb-4 '>
          <span onClick={() => navigate("/customers")} style={{ cursor: "pointer" }}>
            <IoArrowBackOutline size={25} />
          </span>
            <h3 className='m-0' style={{fontSize:'1.2rem'}}>New Customer</h3>
        </div>
        )}

        <div className='main d-flex gap-3 mt-2'>

            <div className='left'>

                <div className='customer-overview row bg-white p-2 gy-2 rounded'>
                <div className="col-6 d-flex gx-4 flex-column">
                    <label>First Name</label>
                    <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} />
                    {errors.firstName && <p className="text-danger">{errors.firstName}</p>}
                </div>

                <div className="col-6 d-flex gx-4 flex-column">
                    <label>Last Name</label>
                    <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} />
                    {errors.lastName && <p className="text-danger">{errors.lastName}</p>}
                </div>

                <div className="col-6 d-flex gx-4 flex-column">
                    <label>WhatsApp No.</label>
                    <input type="text" name="whatsapp" value={formData.whatsapp} onChange={handleChange} />
                    {errors.whatsapp && <p className="text-danger">{errors.whatsapp}</p>}
                </div>

                <div className="col-6 d-flex gx-4 flex-column">
                    <label>Calling No.</label>
                    <input type="text" name="phone" value={formData.phone} onChange={handleChange} />
                    {errors.phone && <p className="text-danger">{errors.phone}</p>}
                </div>

                <div className="col-6 d-flex gx-4 flex-column">
                    <label>Email</label>
                    <input type="text" name="email" value={formData.email} onChange={handleChange} />
                    {errors.email && <p className="text-danger">{errors.email}</p>}
                </div>

                <div className="col-6 d-flex gx-4 flex-column">
                    <label>Password</label>
                    <input type="text" name="password" value={formData.password} onChange={handleChange} />
                    {errors.password && <p className="text-danger">{errors.password}</p>}
                </div>

                <div className="col-6 d-flex gx-4 flex-column">
                    <label>Company</label>
                    <input type="text" name="company" value={formData.company} onChange={handleChange} />
                    {errors.company && <p className="text-danger">{errors.company}</p>}
                </div>

                <div className="col-6 d-flex gx-4 flex-column">
                    <label>GSTIN No.</label>
                    <input
                    className="fs-6 ps-2"
                    type="text"
                    name="gstin"
                    value={formData.gstin}
                    placeholder="Add GSTIN No. to authenticate"
                    onChange={handleChange}
                    />
                    {errors.gstin && <p className="text-danger">{errors.gstin}</p>}
                </div>
                  

                  <div className="row">
  {/* Front Side */}
  <div className="col-12 col-md-6 my-4">
    <div className="media-upload-card p-4 h-100">
      <label className="upload-label mb-3" style={{ fontSize: "1rem" }}>
        Aadhaar Card Front
      </label>

      <div className="upload-area d-flex flex-column justify-content-center align-items-center p-4">
        <input
          type="file"
          id="cheque-front-upload"
          accept="image/*"
          onChange={(e) => handleChequePhotoChange(e, 0)}
          className="d-none"
        />
        <label
          htmlFor="cheque-front-upload"
          className="upload-button btn btn-outline-custom rounded-pill px-4 py-2 mb-2"
        >
          <i className="bi bi-cloud-arrow-up me-2"></i>Choose File
        </label>
        <p className="upload-hint text-muted mb-0">JPEG, PNG (Max 2MB)</p>

        {formData.chequePhotos?.[0] && (
          <div className="preview-container mt-4 text-center">
            <img
              src={`${backendUrl}${formData.chequePhotos[0]}`}
              alt="Front Preview"
              className="img-thumbnail rounded"
              style={{
                maxWidth: "100px",
                maxHeight: "100px",
                objectFit: "contain",
                cursor: "pointer",
              }}
              onClick={handleImageClick}
            />
          </div>
        )}
      </div>
    </div>
  </div>

  {/* Back Side */}
  <div className="col-12 col-md-6 my-4">
    <div className="media-upload-card p-4 h-100">
      <label className="upload-label mb-3" style={{ fontSize: "1rem" }}>
        Aadhaar Card Back
      </label>

      <div className="upload-area d-flex flex-column justify-content-center align-items-center p-4">
        <input
          type="file"
          id="cheque-back-upload"
          accept="image/*"
          onChange={(e) => handleChequePhotoChange(e, 1)}
          className="d-none"
        />
        <label
          htmlFor="cheque-back-upload"
          className="upload-button btn btn-outline-custom rounded-pill px-4 py-2 mb-2"
        >
          <i className="bi bi-cloud-arrow-up me-2"></i>Choose File
        </label>
        <p className="upload-hint text-muted mb-0">JPEG, PNG (Max 2MB)</p>

        {formData.chequePhotos?.[1] && (
          <div className="preview-container mt-4 text-center">
            <img
              src={`${backendUrl}${formData.chequePhotos[1]}`}
              alt="Back Preview"
              className="img-thumbnail rounded"
              style={{
                maxWidth: "100px",
                maxHeight: "100px",
                objectFit: "contain",
                cursor: "pointer",
              }}
              onClick={handleImageClick}
            />
          </div>
        )}
      </div>
    </div>
  </div>
</div>


                          {/* Preview Modal */}
                          {showPreview && (
                            <div 
                              className="modal fade m-0 p-0 show d-block" 
                              style={{ 
                                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                                backdropFilter: 'blur(4px)',
                                zIndex: 2000
                              }}
                              onClick={handleClosePreview}
                            >
                              <div 
                                className="modal-dialog modal-xl d-flex align-items-center justify-content-center p-3"
                                style={{ 
                                  maxWidth: '100vw', 
                                  height: '100vh',
                                  margin: 0
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div 
                                  className="position-relative w-100 h-100 d-flex align-items-center justify-content-center"
                                  style={{ maxWidth: '95vw', maxHeight: '95vh' }}
                                >
                                  {/* Main Image Container */}
                                  <div className="position-relative">
                                    <img
                                      src={`${backendUrl}${formData.chequePhoto}`}
                                      alt="Aadhaar Card Preview"
                                      className="img-fluid rounded-3 shadow-lg"
                                      style={{ 
                                        maxWidth: '100%',
                                        maxHeight: '85vh',
                                        objectFit: 'contain',
                                        backgroundColor: 'white',
                                        border: '2px solid rgba(255, 255, 255, 0.1)',
                                        cursor: 'default'
                                      }}
                                      draggable={false}
                                      onContextMenu={(e) => e.preventDefault()}
                                      onLoad={() => console.log('Image loaded successfully')}
                                      // onError={() => addToast('Failed to load image', 'error')}
                                    />
                                  </div>

                                  {/* Desktop Action Buttons - Top Right */}
                                  <div 
                                    className="d-none d-lg-flex flex-column gap-3" 
                                    style={{ 
                                      position: 'absolute', 
                                      top: '20px', 
                                      right: '20px', 
                                      zIndex: 1070,
                                      pointerEvents: 'auto'
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="btn d-flex align-items-center justify-content-center rounded-circle shadow-lg border-0"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownloadChequePhoto();
                                      }}
                                      title="Download Image"
                                      style={{ 
                                        width: '48px', 
                                        height: '48px',
                                        backgroundColor: '#6B21A8',
                                        color: 'white',
                                        transition: 'all 0.2s ease-in-out',
                                        cursor: 'pointer',
                                        zIndex: 1070
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#7C3AED';
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#6B21A8';
                                        e.currentTarget.style.transform = 'scale(1)';
                                      }}
                                    >
                                      <Download size={20} />
                                    </button>
                                    
                                    <button
                                      type="button"
                                      className="btn d-flex align-items-center justify-content-center rounded-circle shadow-lg border-0"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCopyImageLink();
                                      }}
                                      title="Copy Image Link"
                                      style={{ 
                                        width: '48px', 
                                        height: '48px',
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        color: '#6B21A8',
                                        transition: 'all 0.2s ease-in-out',
                                        cursor: 'pointer',
                                        zIndex: 1070
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = 'white';
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                                        e.currentTarget.style.transform = 'scale(1)';
                                      }}
                                    >
                                      <Link size={20} />
                                    </button>
                                    
                                    <button
                                      type="button"
                                      className="btn d-flex align-items-center justify-content-center rounded-circle shadow-lg border-0"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleClosePreview();
                                      }}
                                      title="Close Preview"
                                      style={{ 
                                        width: '48px', 
                                        height: '48px',
                                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                        color: 'white',
                                        transition: 'all 0.2s ease-in-out',
                                        cursor: 'pointer',
                                        zIndex: 1070
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
                                        e.currentTarget.style.transform = 'scale(1)';
                                      }}
                                    >
                                      <X size={20} />
                                    </button>
                                  </div>

                                  {/* Mobile/Tablet Action Buttons - Bottom Center */}
                                  <div 
                                    className="d-flex d-lg-none gap-3 justify-content-center position-absolute"
                                    style={{ 
                                      bottom: '20px',
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      zIndex: 1070,
                                      padding: '12px 20px',
                                      backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                      borderRadius: '50px',
                                      backdropFilter: 'blur(10px)',
                                      border: '1px solid rgba(255, 255, 255, 0.1)',
                                      pointerEvents: 'auto'
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="btn d-flex align-items-center justify-content-center rounded-circle shadow-sm border-0"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownloadChequePhoto();
                                      }}
                                      title="Download"
                                      style={{ 
                                        width: '44px', 
                                        height: '44px',
                                        backgroundColor: '#6B21A8',
                                        color: 'white',
                                        cursor: 'pointer',
                                        zIndex: 1070
                                      }}
                                    >
                                      <Download size={18} />
                                    </button>
                                    
                                    <button
                                      type="button"
                                      className="btn d-flex align-items-center justify-content-center rounded-circle shadow-sm border-0"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCopyImageLink();
                                      }}
                                      title="Copy Link"
                                      style={{ 
                                        width: '44px', 
                                        height: '44px',
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        color: '#6B21A8',
                                        cursor: 'pointer',
                                        zIndex: 1070
                                      }}
                                    >
                                      <Link size={18} />
                                    </button>
                                    
                                    <button
                                      type="button"
                                      className="btn d-flex align-items-center justify-content-center rounded-circle shadow-sm border-0"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleClosePreview();
                                      }}
                                      title="Close"
                                      style={{ 
                                        width: '44px', 
                                        height: '44px',
                                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                        color: 'white',
                                        cursor: 'pointer',
                                        zIndex: 1070
                                      }}
                                    >
                                      <X size={18} />
                                    </button>
                                  </div>

                                  {/* ESC Key Hint - Top Left */}
                                  <div 
                                    className="d-none d-md-block position-absolute text-white-50 small"
                                    style={{ 
                                      top: '20px', 
                                      left: '20px',
                                      fontFamily: 'monospace',
                                      userSelect: 'none',
                                      fontSize: '12px',
                                      fontWeight: '400'
                                    }}
                                  >
                                    Press ESC to close
                                  </div>

                                  {/* Loading indicator for image */}
                                  {!formData.chequePhoto && (
                                    <div 
                                      className="position-absolute d-flex align-items-center justify-content-center"
                                      style={{
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        color: 'white',
                                        fontSize: '16px'
                                      }}
                                    >
                                      <div className="spinner-border text-light me-2" role="status" style={{ width: '20px', height: '20px' }}>
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                      Loading image...
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}


                
                <div className='d-flex justify-content-end'>
                <div className="d-flex flex-column mb-1 w-25 gap-1">
                  <label>Address Type</label>
                  <select value={selectedAddressType} onChange={handleAddressTypeChange} className='rounded-2 p-1 border border-secondary-subtle'>
                    <option value="HOME">Home</option>
                    <option value="WORK">Work</option>
                    <option value="OTHER">Other</option>
                  </select>
                </div>
                </div>

                <div className="col-md-12 d-flex flex-column">
                    <label>Address</label>
                    <input type="text" name="address" value={formData.address} onChange={handleChange} />
                    {errors.address && <p className="text-danger">{errors.address}</p>}
                </div>

                <div className="col-md-12 d-flex flex-column">
                    <label>Apartment, Suite, etc.</label>
                    <input type="text" name="street" value={formData.street} onChange={handleChange} />
                    {errors.street && <p className="text-danger">{errors.street}</p>}
                </div>

                <div className="col-6 d-flex gx-4 flex-column">
                    <label>Country/Region</label>
                    <input type="text" name="country" value={formData.country} onChange={handleChange} />
                    {errors.country && <p className="text-danger">{errors.country}</p>}
                </div>

                <div className="col-6 d-flex gx-4 flex-column">
                    <label>State</label>
                    <SelectState value={formData.state} onChange={handleChange} />
                    {errors.state && <p className="text-danger">{errors.state}</p>}
                </div>

                <div className="col-6 d-flex gx-4 flex-column">
                    <label>City</label>
                    <input type="text" name="city" value={formData.city} onChange={handleChange} />
                    {errors.city && <p className="text-danger">{errors.city}</p>}
                </div>

                <div className="col-6 d-flex gx-4 flex-column">
                    <label>PIN code</label>
                    <input type="text" name="pinCode" value={formData.pinCode} onChange={handleChange} />
                    {errors.pinCode && <p className="text-danger">{errors.pinCode}</p>}
                </div>



                </div>


            { state &&(

                <div className='bg-white mt-2 p-3 w-100 rounded'>
                <div className='d-flex justify-content-between'>
                <h5>Manage Wallet</h5>

                {/* {manageWallet === false && (
                    <AddBtn clickFunction={handleAddWallet}></AddBtn>
                )} */}

                </div>


                <div className="d-none d-md-block">
                    <label>Add balance</label>
                    <div className='d-flex gap-2 mt-2'>
                    <input value={amount} onChange={(e) => setAmount(e.target.value)} className='rounded border border-secondary-subtle p-1 w-50' placeholder='₹ INR'></input>
                    {/* <AddBtn clickFunction={handleAddMoney}></AddBtn> */}
                    <input
                        value={source}
                        onChange={(e) => setSource(e.target.value)}
                        className="rounded border border-secondary-subtle p-1 w-100"
                        placeholder="Comment / Source (e.g., Manual adjustment)"
                      />

                  <div className='d-flex gap-2'>
                   <button
                              className="btn d-flex p-0 align-items-center justify-content-center"
                              style={{
                                width: '2.2rem',
                                height: '2.2rem',
                                backgroundColor: '#f7ecffff',
                                border: '1px solid #6B21A8',
                                color: '#6B21A8',
                                borderRadius: '0.4rem',
                              }}
                              onClick={handleAddMoney}
                            >
                              <IoAddOutline size={24} />
                            </button>

                            {/* - Subtract Button */}
                            <button
                              className="btn d-flex p-0 align-items-center justify-content-center"
                              style={{
                                width: '2.2rem',
                                height: '2.2rem',
                                backgroundColor: 'rgba(220,53,69,0.1)',
                                border: '1px solid #dc3545',
                                color: '#dc3545',
                                borderRadius: '0.4rem',
                              }}
                              onClick={handleSubtractMoney}
                            >
                              <FaMinus size={12} />
                            </button>
                            </div>
                    </div>
                </div>




                <div className="table-ctn">
                {loading ? (
                  <div className="py-5 text-body-tertiary d-flex flex-column justify-content-center align-items-center">
                    <span>Loading...</span>
                  </div>
                ) : transactions.length > 0 ? (
                  <>
                    {/* Desktop Table View */}
                    <div className="d-none d-md-block">
                      <Table>
                        <thead>
                          <tr>
                            <th>Source</th>
                            {/* <th className=" text-center">Invoice No.</th> */}
                            <th className=" text-center">Type</th>
                            <th className=" text-center">Amount</th>
                            <th className=" text-center">Date</th>
                            <th className=" text-center">Credit Note</th>
                          </tr>
                        </thead>
                        <tbody>
                          {transactions.slice().reverse().map((item, ix) => (
                            <tr key={ix}>
                              <td>{item.source}</td>
                              {/* <td className=" text-center">INV-87565</td> */}
                              <td className=" text-center"
                                style={{
                                  color: item.type === "CREDIT" ? "#3CAA82" : "#FF0000",
                                }}
                              >
                                {item.type}
                              </td>

                              <td className="text-center"
                                style={{
                                  color: item.type === "CREDIT" ? "#3CAA82" : "#FF0000", 
                                }}
                              >
                                {item.type === "DEBIT" ? "−" : ""}
                                ₹{item.amount.toFixed(0)} 
                              </td>
                             
                              <td className="text-center">
                                {new Date(item.createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}
                              </td>


                              {(item.source?.includes("Refund for cancellation") || item.source?.includes("Refund for return")) && (
                              <td className=" text-center pr-4">
                                <button
                                className="btn p-0"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDownloadCreditReceipt(item.source);
                                }}
                                >
                                <FiDownload size={20}/>
                                </button>
                              </td>
                               )}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    {/* Mobile Card View */}
                    <div className="d-block d-md-none">
                    <label>Add balance</label>
                   <div className="d-flex gap-2 mt-2">
                          {/* Amount Field */}
                          <input
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            className="rounded border border-secondary-subtle p-1 w-50"
                            placeholder="₹INR"
                          />

                          {/* Source & Buttons Group */}
                          
                            {/* Comment Field */}
                            <input
                              value={source}
                              onChange={(e) => setSource(e.target.value)}
                              className="rounded border border-secondary-subtle p-1 w-100"
                              placeholder="Add remarks"
                            />
                           
                           <div className="d-flex gap-2">
                            {/* + Add Button */}
                            <button
                              className="btn d-flex p-0 align-items-center justify-content-center"
                              style={{
                                width: '2.2rem',
                                height: '2.2rem',
                                backgroundColor: '#f7ecffff',
                                border: '1px solid #6B21A8',
                                color: '#6B21A8',
                                borderRadius: '0.4rem',
                                // lineHeight: 1,
                              }}
                              onClick={handleAddMoney}
                            >
                              <IoAddOutline size={19} />
                            </button>

                            {/* - Subtract Button */}
                            <button
                              className="btn d-flex p-0 align-items-center justify-content-center"
                              style={{
                                width: '2.2rem',
                                height: '2.2rem',
                                backgroundColor: 'rgba(220,53,69,0.1)',
                                border: '1px solid #dc3545',
                                color: '#dc3545',
                                borderRadius: '0.4rem',
                              }}
                              onClick={handleSubtractMoney}
                            >
                              <FaMinus size={12} />
                            </button>
                          </div>
                        </div>


                      <div className="transaction-history-mobile">
                        {transactions.slice().reverse().map((item, ix) => (
                          <div key={ix} className="transaction-card mb-3 p-3 border rounded-3 bg-light">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div className="transaction-info flex-grow-1">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <span
                                    className="transaction-source fw-medium text-dark"
                                    style={{
                                      fontSize: '0.9rem',
                                      width: '60%',
                                      // whiteSpace: 'nowrap',
                                      // overflow: 'hidden',
                                      // textOverflow: 'ellipsis'
                                    }}
                                  >
                                    {item.source}
                                  </span>

                                  <span 
                                    className="transaction-amount fw-bold text-end"
                                    style={{
                                      color: item.type === "CREDIT" ? "#3CAA82" : "#FF0000",
                                      fontSize: '1.1rem',
                                      width: '40%',
                                      alignSelf: 'flex-center',
                                    }}
                                  >
                                    {item.type === "DEBIT" ? "−" : "+"}₹{item.amount.toFixed(0)}
                                  </span>
                                </div>

                                
                                <div className="d-flex justify-content-between align-items-center">
                                  {/* <span 
                                    className="transaction-amount fw-bold"
                                    style={{
                                      color: item.type === "CREDIT" ? "#3CAA82" : "#FF0000",
                                      fontSize: '1.1rem'
                                    }}
                                  >
                                    {item.type === "DEBIT" ? "−" : "+"}₹{item.amount.toFixed(0)}
                                  </span> */}
                                   <div className="transaction-time">
                                    <small className="text-muted" style={{fontSize: '0.75rem'}}>
                                      {new Date(item.createdAt).toLocaleTimeString("en-IN", { 
                                        timeZone: "Asia/Kolkata",
                                        hour: '2-digit',
                                        minute: '2-digit'
                                      })}
                                    </small>
                                  </div>
                                  <div className="d-flex align-items-center gap-2">
                                    <small className="text-muted" style={{fontSize: '0.8rem'}}>
                                      {new Date(item.createdAt).toLocaleDateString("en-IN", { 
                                        timeZone: "Asia/Kolkata",
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric'
                                      })}
                                    </small>
                                    
                                    {(item.source?.includes("Refund for cancellation") || item.source?.includes("Refund for return")) && (
                                    <button
                                        className="btn btn-sm rounded-circle bg-white text-dark d-flex align-items-center justify-content-center"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDownloadCreditReceipt(item.source);
                                        }}
                                        style={{
                                          width: '32px',
                                          height: '32px',
                                          border: '1px solid #dee2e6', // dark border
                                        }}
                                      >
                                        <FiDownload size={18} />
                                      </button>

                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="py-5 text-body-tertiary d-flex flex-column justify-content-center align-items-center">
                    <RiFilePaper2Line size={50} />
                    <h5 className="fs-6">There's no transaction till now!</h5>
                  </div>
                )}
              </div>

                                    
                </div>
            )}

                
                    <div className='d-flex justify-content-between mt-4 mb-4'>
                        <DeleteBtn clickFunction={handleDelete}></DeleteBtn>
                        <SubmitBtn text={'Save'} clickFunction={handleSubmit}/>
                    </div>

            </div>


            <div className='right'>
            <div className='bg-white p-3 rounded'>
                <h5 className="fs-6">Status</h5>
                <StatusInput status={status} onStatusChange={handleStatusChange}></StatusInput>
            </div>

            <div className='bg-white p-3 rounded mt-2'>
              <div className='d-flex gap-3 border-bottom'>
                  <div className="d-flex gap-3 position-relative" style={{ width: '100px', height: '100px' }}>
                      <svg width="100" height="100" viewBox="0 0 100 100">
                          <circle
                              cx="50"
                              cy="50"
                              r="35"
                              stroke={walletBalance > 0 ? "#6B21A8" : "#B9C0CD"} // Blue if wallet has balance
                              strokeWidth="5"
                              fill="none"
                              strokeDasharray="240"
                              strokeDashoffset="70"
                          />
                      </svg>

                      {/* Icon in the center */}
                      <div
                          className="position-absolute d-flex justify-content-center align-items-center"
                          style={{ top: 0, left: 0, width: '100%', height: '100%', color: walletBalance > 0 ? "#6B21A8" : "#6c757d" }}
                      >
                          <VscCreditCard size={30} />
                      </div>
                  </div>

                  <div
                  className="d-flex flex-column justify-content-center align-items-start"
                >
                  <h5 style={{ fontSize: '1rem' }}>Wallet Balance</h5>
                  <h5 className={`fs-4 mt-2 ${walletBalance > 0 ? 'text-custom' : 'text-secondary'}`}>
                    ₹{walletBalance?.toFixed(0) || 0}
                  </h5>
                </div>

              </div>
          </div>


            {state?.index !== undefined && (
               <div className="bg-white p-3 rounded-3 mt-3 segment-sec border border-light">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                      <h5 className="fs-6 mb-0 fw-semibold text-dark">Segments</h5>
                      {selectedSegments.length > 0 && (
                          <small className="text-muted">{selectedSegments.length} selected</small>
                      )}
                  </div>
                  
                  <div className="position-relative mb-3">
                      <select
                          className="form-select border-secondary-subtle rounded-2 py-2 px-3 w-100"
                          value={selectedValue}
                          onChange={addSegmentAsChip}
                          style={{
                              fontSize: '14px',
                              transition: 'all 0.2s ease-in-out',
                              backgroundColor: '#fafafa'
                          }}
                          onFocus={(e) => {
                              e.currentTarget.style.borderColor = '#6B21A8';
                              e.currentTarget.style.boxShadow = '0 0 0 0.2rem rgba(13, 110, 253, 0.25)';
                          }}
                          onBlur={(e) => {
                              e.currentTarget.style.borderColor = '#dee2e6';
                              e.currentTarget.style.boxShadow = 'none';
                          }}
                      >
                          <option value="">Choose a segment...</option>
                          {segments.map((segment, index) => (
                              <option 
                                  key={index} 
                                  value={segment.segmentTitle}
                                  title={segment.segmentTitle}
                                  style={{
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      maxWidth: '100%'
                                  }}
                              >
                                  {segment.segmentTitle.length > 40 
                                      ? `${segment.segmentTitle.substring(0, 40)}...` 
                                      : segment.segmentTitle
                                  }
                              </option>
                          ))}
                      </select>
                  </div>

                  {/* Display selected segments as chips */}
                  <div className="chips-container">
                      {selectedSegments.length === 0 ? (
                          <div className="text-center py-3 text-muted">
                              <small>No segments selected</small>
                          </div>
                      ) : (
                          <div className="d-flex flex-wrap gap-2">
                              {selectedSegments.map((segment, index) => (
                                  <span
                                      key={index}
                                      className="chip d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill "
                                      style={{
                                          backgroundColor: '#6b21a80e',
                                          border: '1px solid #6B21A8',
                                          fontSize: '0.8rem',
                                          fontWeight: '500',
                                          color: '#6B21A8',
                                          transition: 'all 0.2s ease-in-out',
                                          cursor: 'default'
                                      }}
                                      // onMouseEnter={(e) => {
                                      //     e.currentTarget.style.backgroundColor = '#6b21a80e';
                                      //     e.currentTarget.style.borderColor = '#6B21A8';
                                      // }}
                                      // onMouseLeave={(e) => {
                                      //     e.currentTarget.style.backgroundColor = '#6b21a80e';
                                      //     e.currentTarget.style.borderColor = '#6B21A8';
                                      // }}
                                  >
                                      <span className="text-truncate" style={{ maxWidth: '200px' }}>
                                          {segment.segmentTitle}
                                      </span>
                                      <button
                                          onClick={() => removeSegmentChip(index)}
                                          className="btn btn-sm p-0 border-0 bg-transparent d-flex align-items-center justify-content-center ms-1"
                                          style={{
                                              width: '18px',
                                              height: '18px',
                                              borderRadius: '50%',
                                              color: '#1d1e1fff',
                                              fontSize: '14px',
                                              transition: 'all 0.2s ease-in-out'
                                          }}
                                          // onMouseEnter={(e) => {
                                          //     e.currentTarget.style.backgroundColor = '#dc3545';
                                          //     e.currentTarget.style.color = 'white';
                                          // }}
                                          // onMouseLeave={(e) => {
                                          //     e.currentTarget.style.backgroundColor = 'transparent';
                                          //     e.currentTarget.style.color = '#6c757d';
                                          // }}
                                          aria-label={`Remove ${segment.segmentTitle}`}
                                      >
                                          ×
                                      </button>
                                  </span>
                              ))}
                          </div>
                      )}
                  </div>
              </div>
            )}

            



            </div>

        </div>

{/* Toast Notification */}
     <div className="fixed top-4 right-4 z-50 space-y-2">
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        message={toast.message}
                        type={toast.type}
                        onClose={() =>
                            setToasts((prev) => prev.filter((t) => t.id !== toast.id))
                        }
                    />
                ))}
            </div>


    </div>
  )
}

export default AddCustomerPage